<template>
  <div>
    <b-card>
      <validation-observer ref="searchForm">
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="2">
              <b-form-group>
                <h5 class="font-weight-bold">
                  Grlo
                </h5>
                <validation-provider
                  #default="{ errors }"
                  name="cattle"
                  vid="cattle"
                  ref="cattleValidationProvider"
                >
                  <vue-autosuggest
                    :suggestions="filteredOptions"
                    :limit="10"
                    :input-props="{
                      id: 'autosuggest__input',
                      class: 'form-control',
                      placeholder: 'Odaberite grlo',
                    }"
                    @input="onInputChange"
                    @selected="onCowSelected"
                    ref="cowAutosuggest"
                  >
                    <template slot-scope="{ suggestion }">
                      <span class="my-suggestion-item">{{
                        suggestion.item.name
                      }}</span>
                    </template>
                  </vue-autosuggest>
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <h5 class="font-weight-bold">
                  Od
                </h5>
                <validation-provider
                  #default="{ errors }"
                  name="dateFrom"
                  vid="dateFrom"
                  ref="validationDateFrom"
                >
                  <flat-pickr
                    v-model="searchModel.dateFrom"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      dateFormat: 'd.m.Y H:i',
                      time_24hr: true,
                    }"
                  />
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <h5 class="font-weight-bold">
                  Do
                </h5>
                <validation-provider
                  #default="{ errors }"
                  name="dateTo"
                  vid="dateTo"
                  ref="validationDateTo"
                >
                  <flat-pickr
                    v-model="searchModel.dateTo"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      dateFormat: 'd.m.Y H:i',
                      time_24hr: true,
                    }"
                  />
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="form-button btn-block"
                type="submit"
              >
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span class="align-middle">Prikaži</span>
              </b-button>
            </b-col>
            <b-col md="2">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                class="form-button btn-block"
                @click="clickResetSearch"
              >
                <feather-icon icon="XIcon" class="mr-50" />
                <span class="align-middle">Poništi</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
    <AllCattleMap
      v-if="showAllCattle"
      @clickOnMarker="clickOnMarker"
      @onSearchExecuted="showAllCattle = false"
    />
    <CowMovingHistoryMap v-else />
  </div>
</template>
<script>
import moment from "moment";
import {
  BCardActions,
  BCard,
  BRow,
  BFormGroup,
  BCol,
  BForm,
  BButton,
  BAlert,
} from "bootstrap-vue";
import store from "@/store/index";
import AllCattleMap from "./AllCattleMap";
import CowMovingHistoryMap from "./CowMovingHistoryMap";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { mapState } from "vuex";
import { VueAutosuggest } from "vue-autosuggest";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, min, confirmed } from "@validations";
import { heightFade } from "@core/directives/animations";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    AllCattleMap,
    CowMovingHistoryMap,
    BCardActions,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BButton,
    VueAutosuggest,
    BAlert,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  beforeRouteEnter(to, from, next) {
    let getLatestData = store.dispatch("cattle/GET_LATEST_DATA_FOR_ALL_CATTLE");
    let getCattleForAutoSuggest = store.dispatch(
      "cattle/GET_ALL_CATTLE_FOR_AUTO_SUGGEST"
    );
    Promise.all([getLatestData, getCattleForAutoSuggest]).then(() => {
      next();
    });
  },
  data() {
    return {
      moment: moment,
      showAllCattle: true,
      filteredOptions: [],
      searchModel: {
        dateFrom: null,
        dateTo: null,
        cow: null,
      },
      formNotCorrect: false,
    };
  },
  mounted() {
    localize("en", {
      code: "en",
      fields: {
        cattle: {
          required: "Polje je obavezno",
        },
        dateFrom: {
          required: "Polje je obavezno",
        },
        dateTo: {
          required: "Polje je obavezno",
        },
      },
    });
  },
  computed: {
    ...mapState({
      cattleForAutoSuggest: (state) => state.cattle.cattleForAutoSuggest,
    }),
  },
  methods: {
    clickResetSearch() {
      this.searchModel.cow = null;
      this.searchModel.dateFrom = null;
      this.searchModel.dateTo = null;
      this.$refs.cowAutosuggest.internalValue = "";
      this.$refs.cowAutosuggest.searchInputOriginal = "";
      this.showAllCattle = true;
      setTimeout(() => {
        this.$refs.validationDateTo.errors = [];
        this.$refs.validationDateFrom.errors = [];
      }, 50);
      setTimeout(() => {
        this.$refs.validationDateTo.errors = [];
        this.$refs.validationDateFrom.errors = [];
      }, 200);
    },
    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.cattleForAutoSuggest
        .filter(
          (item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1
        )
        .slice(0, 10);
      this.filteredOptions = [
        {
          data: filteredData,
        },
      ];
    },
    onCowSelected(option) {
      this.searchModel.cow = option.item;
      this.$refs.cattleValidationProvider.errors = [];
    },
    submitForm() {
      var $this = this;

      this.$refs.searchForm.validate().then((success) => {
        if ($this.searchModel.cow != null)
          $this.$refs.cattleValidationProvider.errors = [];

        store
          .dispatch("cattle/GET_COW_MOVING_HISTORY", $this.searchModel)
          .then((response) => {
            if (response.data.cowMovingHistory.length > 0)
              store.commit(
                "cattle/SET_CENTER",
                response.data.cowMovingHistory[
                  response.data.cowMovingHistory.length - 1
                ].position
              );

            $this.showAllCattle = false;
          });
      });
    },
    clickOnMarker(cow) {
      var dateFrom = new Date();
      dateFrom.setDate(dateFrom.getDate() - 3);

      this.searchModel.cow = cow;
      this.searchModel.dateTo = new Date();
      this.searchModel.dateFrom = dateFrom;

      this.$refs.cowAutosuggest.internalValue =
        cow.name + " (" + cow.earringNumber + ")";
      this.$refs.cowAutosuggest.searchInputOriginal =
        cow.name + " (" + cow.earringNumber + ")";

      //FORMAT DATETIME FOR BACKEND
      this.searchModel.dateTo = moment(this.searchModel.dateTo).format(
        "DD.MM.YYYY HH:mm"
      );
      this.searchModel.dateFrom = moment(this.searchModel.dateFrom).format(
        "DD.MM.YYYY HH:mm"
      );

      var $this = this;
      store
        .dispatch("cattle/GET_COW_MOVING_HISTORY", this.searchModel)
        .then((response) => {
          if (response.data.cowMovingHistory.length > 0)
            store.commit(
              "cattle/SET_CENTER",
              response.data.cowMovingHistory[
                response.data.cowMovingHistory.length - 1
              ].position
            );

          $this.showAllCattle = false;
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.form-button {
  margin-top: 25px;
}
</style>
